<template>
  <PModal title="Choix du mode de signature" :persistent="locked" :disable-persistent-animation="true">
    <template #default>
      <PRadio v-model="pades" label="" :options="options" />
    </template>

    <template #actions="{ close }">
      <div class="flex gap-1 items-end justify-end">
        <PButton mode="secondary" @click="close" :disabled="locked">Annuler</PButton>
        <PButton mode="primary" @click="emit('sign', { pades })" :loading="loading"> Signer et fermer </PButton>
      </div>
    </template>
  </PModal>
</template>

<script setup lang="ts">
import { PButton, PModal, PRadio } from "@pasta/box-v2";
import { ref } from "vue";

type Props = { loading: boolean; locked: boolean };
defineProps<Props>();

const emit = defineEmits<{
  (event: "sign", options: { pades: boolean }): void;
}>();

const pades = ref<boolean>(false);

const options = [
  { label: "Signature simple", value: false },
  { label: "Signature identité renforcée", value: true },
];
</script>
